// Swiperを設定
const productImageSwiper = new Swiper('.product-media__main', {
  slidesPerView: 1,
  pagination: {
    el: '.swiper-pagination',
    type: 'fraction',
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  on: {
    slideChange: function () {
      // スライドが変更されたときに実行されるコード
      var activeIndex = this.activeIndex;
      // Lightboxの開始インデックスを更新
      if (window.Lightbox && window.Lightbox.prototype) {
        window.Lightbox.prototype.currentImageIndex = activeIndex;
      }
    }
  }
});

// グローバルにSwiperインスタンスを公開
window.productImageSwiper = productImageSwiper[1];

const productImageSwiperSp = new Swiper('.media-swiper-sp', {
  slidesPerView: 5.3,
  spaceBetween: 5,
  navigation: {
    nextEl: '.media-swiper-sp__next',
    prevEl: '.media-swiper-sp__prev',
  },
});

window.onload = function () {
  const productRecommendationSameSwiper = new Swiper('.products-card-slider_same', {
    slidesPerView: 5,
    spaceBetween: 12,
    navigation: {
      nextEl: '.products-card-slider_same .swiper-button-next',
      prevEl: '.products-card-slider_same .swiper-button-prev',
    },
    breakpoints: {
      // 0以上（上限なし）の範囲で条件指定
      0: {
        slidesPerView: 2.5
      },
      750: {
        slidesPerView: 5
      }
    }
  });
  const productRecommendationAllSwiper = new Swiper('.products-card-slider_all', {
    slidesPerView: 5,
    spaceBetween: 12,
    navigation: {
      nextEl: '.products-card-slider_all .swiper-button-next',
      prevEl: '.products-card-slider_all .swiper-button-prev',
    },
    breakpoints: {
      // 0以上（上限なし）の範囲で条件指定
      0: {
        slidesPerView: 2.5
      },
      750: {
        slidesPerView: 5
      }
    }
  });
};
if (window.innerWidth <= 750) {
  // 750px以下の場合のみSwiperを初期化
  const productRecommendationSameSwiper = new Swiper('.products-card-slider_same', {
    slidesPerView: 2.5,
    spaceBetween: 12,
    navigation: {
      nextEl: '.products-card-slider_same .swiper-button-next',
      prevEl: '.products-card-slider_same .swiper-button-prev',
    },
  });

  const productRecommendationAllSwiper = new Swiper('.products-card-slider_all', {
    slidesPerView: 2.5,
    spaceBetween: 12,
    navigation: {
      nextEl: '.products-card-slider_all .swiper-button-next',
      prevEl: '.products-card-slider_all .swiper-button-prev',
    },
  });
};
// 全てのスライダーを取得
const productMedia = document.querySelectorAll('.product-media__slider.swiper-slide');
const halfProductMedia = Array.from(productMedia).slice(0, Math.ceil(productMedia.length / 2));

// 商品画像一覧を押した時のイベント
const productMediaAllImages = document.querySelectorAll('.product-media__all__item');
productMediaAllImages.forEach(image => {
  image.addEventListener('click', () => {
    const index = image.dataset.index;
    // 商品画像をスライドさせる
    productImageSwiper.forEach(swiper => {
      // spのdata indexはpcのdata-index分足されているため、それを差し引く
      if (index > swiper.slides.length) {
        const spIndex = index - swiper.slides.length;
        swiper.slideTo(spIndex - 1);
      } else {
        swiper.slideTo(index - 1);
      }
    });
  });
});

// 対象カラーのみ表示
const displayCurrentColor = color => {
  const selectedColor = color;
  // 商品画像一覧の全ての画像を非表示にする
  productMediaAllImages.forEach(image => {
    image.style.display = 'none';
  });

  // 選択したカラーの画像のみ表示する
  const matchedImages = document.querySelectorAll(
    `.product-media__all__item[data-color="${selectedColor}"]`
  );

  matchedImages.forEach((image, index) => {
    image.style.display = 'block';
    image.dataset.index = index + 1;
  });

  // 選択したカラーのスライドのみ追加する
  const matchedSlides = Array.from(halfProductMedia).filter(slide => {
    return slide.getAttribute('data-color') === selectedColor;
  });

  // PC版スワイパーの更新
  productImageSwiper.forEach(swiper => {
    swiper.removeAllSlides();
    matchedSlides.forEach(slide => {
      const newSlide = slide.cloneNode(true);
      swiper.appendSlide(newSlide);
    });
    swiper.update();
    swiper.slideTo(0);
  });

  // SP版スワイパーの更新
  productImageSwiperSp.removeAllSlides();
  matchedSlides.forEach((slide, index) => {
    const newSlide = slide.cloneNode(true);
    const imgTag = newSlide.querySelector('a img');
    if (imgTag) {
      newSlide.innerHTML = '';
      newSlide.appendChild(imgTag);
    }
    productImageSwiperSp.appendSlide(newSlide);
    newSlide.addEventListener('click', () => {
      productImageSwiper.forEach(swiper => {
        swiper.slideTo(index);
      });
    });
  });
  productImageSwiperSp.update();
  productImageSwiperSp.slideTo(0);
};

// URLパラメータからカラーIDを取得
const getColorIdByUrlParam = () => {
  // URLパラメータからvariantを取得。ない場合はcolor_idとする
  const selectedVariantId = new URL(window.location.href).searchParams.get('variant');
  const selectedVariant = variants.find(variant => variant.id === selectedVariantId);
  if (selectedVariant && selectedVariant.image_alt) {
    return (
      selectedVariant.image_alt.split(',')[1] ??
      new URL(window.location.href).searchParams.get('color_id')
    );
  } else {
    return new URL(window.location.href).searchParams.get('color_id');
  }
};
const productImageClickFavorite = colorId => {
  // お気に入り登録を更新する
  if (typeof updateWishlistStatusFunc === 'function') {
    const colorVariantIds = variants
      .filter(variant => variant.image_alt && variant.image_alt.split(',')[1] === colorId)
      .map(variant => variant.id);
    if (colorVariantIds && colorVariantIds.length) {
      updateWishlistStatusFunc(colorVariantIds);
    }
  }
};

// 読み込み時に最初のカラーのみ絞り込む
window.addEventListener('DOMContentLoaded', () => {
  // カラーの要素を取得
  const productMediaColors = document.querySelectorAll('.product-media__colors__item');

  // URLパラメータからカラーIDを取得
  const selectedColorId = getColorIdByUrlParam();

  // 代表色のカラーを取得
  const repColorId = document.querySelector('#repColorId');

  let selectColorNode = null;
  productMediaColors.forEach(mediaColor => {
    if (mediaColor.getAttribute('data-color') == selectedColorId) {
      selectColorNode = mediaColor;
    }
  });

  // selectedColorIdがない場合のみrepColorIdをチェック
  if (!selectColorNode && repColorId) {
    productMediaColors.forEach(mediaColor => {
      if (mediaColor.getAttribute('data-color') == repColorId.value) {
        selectColorNode = mediaColor;
      }
    });
  }
  // URLパラメータでなければ先頭から取得
  const initialColor =
    selectedColorId || repColorId.value || productMediaColors[0].getAttribute('data-color');
  (selectColorNode ?? productMediaColors[0]).classList.add('active');
  checkInterval = setInterval(() => {
    // スライドが1以上になったかチェック
    if (productImageSwiper[0].slides.length > 0) {
      displayCurrentColor(initialColor);
      clearInterval(checkInterval);
    }
  }, 100);

  // sp要素のカラーの要素を取得
  const spProductMediaColors = document.querySelectorAll('.product-media__colors__item--sp');

  let spSelectColorNode = null;
  spProductMediaColors.forEach(mediaColor => {
    if (mediaColor.getAttribute('data-color') == selectedColorId) {
      spSelectColorNode = mediaColor;
    }
  });

  // selectedColorIdがない場合のみrepColorIdをチェック
  if (!spSelectColorNode && repColorId) {
    spProductMediaColors.forEach(mediaColor => {
      if (mediaColor.getAttribute('data-color') == repColorId.value) {
        spSelectColorNode = mediaColor;
      }
    });
  }

  const spInitialColor =
    selectedColorId || repColorId.value || spProductMediaColors[0].getAttribute('data-color');
  (spSelectColorNode ?? spProductMediaColors[0]).classList.add('active');
  checkIntervalSp = setInterval(() => {
    // スライドが1以上になったかチェック
    if (productImageSwiper[1].slides.length > 0) {
      displayCurrentColor(spInitialColor);
      clearInterval(checkIntervalSp);
    }
  }, 100);
  // 購入可能数上限のエラーメッセージを削除する処理
  const removeNoAddMessage = (display = '') => {
    const messageClass = display === 'sp' ? '.no-add-message-sp' : '.no-add-message';
    const noAddMessages = document.querySelector(messageClass);
    if (noAddMessages) {
      noAddMessages.remove();
    }
  };
  productImageClickFavorite(selectedColorId ?? repColorId);

  // 一般的な要素更新関数
  function updateElements(selector, attribute, updater, color) {
    const elements = document.querySelectorAll(selector);
    const selectedValue = color.getAttribute(attribute);

    elements.forEach(element => {
      updater(element, selectedValue);
    });
  }

  // innerHTMLの更新用関数
  function updateInnerHTML(element, value) {
    if (value) {
      element.parentNode.classList.remove('hidden');
      element.innerHTML = value;
    } else {
      element.parentNode.classList.add('hidden');
    }
  }

  // 画像の更新用関数
  function updateImageSource(element, value) {
    if (value) {
      element.parentNode.parentNode.classList.remove('hidden');
      element.src = `https://cdn.shopify.com/s/files/1/0693/8207/8776/files/${value}.jpg`;
    } else {
      element.parentNode.parentNode.classList.add('hidden');
    }
  }

  //　初期表示時の素材情報の更新
  updateElements(
    '.productDetail__info__materialInfo__detail.productOrigin',
    'data-origin',
    updateInnerHTML,
    selectColorNode
  );
  updateElements(
    '.productDetail__info__materialInfo__detail.productMaterial',
    'data-material',
    updateInnerHTML,
    selectColorNode
  );
  updateElements(
    '.productDetail__info__materialInfo__washing.productWashing',
    'data-washing',
    updateImageSource,
    selectColorNode
  );


  // カラーを選択した時のイベント
  productMediaColors.forEach(color => {
    color.addEventListener('click', () => {
      const productCurrentColor = document.querySelector('.product-media__colors__item.active');
      productCurrentColor.classList.remove('active');
      color.classList.add('active');
      // 選択したカラーの値を取得
      const selectedColor = color.getAttribute('data-color');
      displayCurrentColor(selectedColor);
      CurrentSizeFunc();

      // カートボタンを初期化
      const cartAddBtn = document.querySelector('.product-cart-add__add');
      const cartAddBtnText = document.querySelector('.product-cart-add__text');
      cartAddBtn.classList.remove('active');
      cartAddBtnText.innerHTML = 'カートに入れる';

      // エラーメッセージを初期化
      removeNoAddMessage();

      const reservedText = document.querySelector('#reservedText');
      reservedText.innerHTML = '';

      // 要素の更新
      updateElements(
        '.productDetail__info__materialInfo__detail.productOrigin',
        'data-origin',
        updateInnerHTML,
        color
      );
      updateElements(
        '.productDetail__info__materialInfo__detail.productMaterial',
        'data-material',
        updateInnerHTML,
        color
      );
      updateElements(
        '.productDetail__info__materialInfo__washing.productWashing',
        'data-washing',
        updateImageSource,
        color
      );
      // お気に入り登録を更新する
      productImageClickFavorite(selectedColor);
    });
  });
  // カラーを選択した時のイベント
  spProductMediaColors.forEach(color => {
    color.addEventListener('click', () => {
      const productCurrentColor = document.querySelector('.product-media__colors__item--sp.active');
      productCurrentColor.classList.remove('active');
      color.classList.add('active');
      // 選択したカラーの値を取得
      const selectedColor = color.getAttribute('data-color');
      displayCurrentColor(selectedColor);
      SpCurrentSizeFunc();

      // カートボタンを初期化
      const cartAddBtnSp = document.querySelector('.product-cart-add__add.sp');
      const cartAddBtnTextSP = document.querySelector('.product-cart-add__text.sp');
      cartAddBtnSp.classList.remove('active');
      cartAddBtnTextSP.innerHTML = 'カートに入れる';

      // エラーメッセージを初期化
      removeNoAddMessage('sp');

      // 一般的な要素更新関数
      function updateElements(selector, attribute, updater) {
        const elements = document.querySelectorAll(selector);
        const selectedValue = color.getAttribute(attribute);

        elements.forEach(element => {
          updater(element, selectedValue);
        });
      }

      // innerHTMLの更新用関数
      function updateInnerHTML(element, value) {
        if (value) {
          element.parentNode.classList.remove('hidden');
          element.innerHTML = value;
        } else {
          element.parentNode.classList.add('hidden');
        }
      }

      // 画像の更新用関数
      function updateImageSource(element, value) {
        if (value) {
          element.parentNode.parentNode.classList.remove('hidden');
          element.src = `https://cdn.shopify.com/s/files/1/0693/8207/8776/files/${value}.jpg`;
        } else {
          element.parentNode.parentNode.classList.add('hidden');
        }
      }

      // 要素の更新
      updateElements(
        '.productDetail__info__materialInfo__detail.productOrigin',
        'data-origin',
        updateInnerHTML
      );
      updateElements(
        '.productDetail__info__materialInfo__detail.productMaterial',
        'data-material',
        updateInnerHTML
      );
      updateElements(
        '.productDetail__info__materialInfo__washing.productWashing',
        'data-washing',
        updateImageSource
      );
      productImageClickFavorite(selectedColor);
    });
  });

  const zoomArea = document.querySelector('.product-media__main__zoom-area');
  const productMediaMain = document.querySelector('.product-media__main');

  const handleMouseMove = (event) => {
    if (window.innerWidth < 1025) {
      return;
    }
    const sliderImage = productMediaMain.querySelector('.swiper-slide-active .product-media__slider-image');
    if (zoomArea && sliderImage) {
        const rect = sliderImage.getBoundingClientRect();
        let x = event.clientX - rect.left;
        let y = event.clientY - rect.top;

        // マウスがボタン上にあるかチェック
        const isOnButton = event.target.classList.contains('swiper-button-next') ||
                           event.target.classList.contains('swiper-button-prev');

        if (isOnButton) {
            // ボタン上にある場合は半透明要素を非表示に
            zoomArea.style.display = 'none';
        } else {
            // ボタン上にない場合は表示して位置を更新
            zoomArea.style.display = 'block';

            // 画像内の相対位置を計算（0から1の範囲に正規化）
            const relativeX = Math.max(0, Math.min(1, x / rect.width));
            const relativeY = Math.max(0, Math.min(1, y / rect.height));

            // zoomAreaの位置を更新（パーセンテージで指定）
            let zoomAreaLeft = relativeX * rect.width;
            let zoomAreaTop = relativeY * rect.height;

            // zoomAreaがproduct-media__mainの表示領域からはみ出さないように制限
            const zoomAreaWidth = zoomArea.offsetWidth;
            const zoomAreaHeight = zoomArea.offsetHeight;

            if (zoomAreaLeft < zoomAreaWidth / 2) {
                zoomAreaLeft = zoomAreaWidth / 2;
            } else if (zoomAreaLeft > rect.width - zoomAreaWidth / 2) {
                zoomAreaLeft = rect.width - zoomAreaWidth / 2;
            }

            if (zoomAreaTop < zoomAreaHeight / 2) {
                zoomAreaTop = zoomAreaHeight / 2;
            } else if (zoomAreaTop > rect.height - zoomAreaHeight / 2) {
                zoomAreaTop = rect.height - zoomAreaHeight / 2;
            }

            zoomArea.style.left = `${zoomAreaLeft}px`;
            zoomArea.style.top = `${zoomAreaTop}px`;
            zoomArea.style.transform = 'translate(-50%, -50%)';
        }
    }
  };

  window.addEventListener('load', () => {
    if (productMediaMain) {
      productMediaMain.addEventListener('mousemove', handleMouseMove);
    }
  });

  // マウスがスライダーから離れたときに半透明要素を非表示にする
  productMediaMain.addEventListener('mouseleave', () => {
    if (zoomArea) {
        zoomArea.style.display = 'none';
    }
  });

  // Lightboxが利用可能になるまで待つ
  function waitForLightbox(callback) {
    if (window.Lightbox) {
      callback();
    } else {
      setTimeout(function() { waitForLightbox(callback); }, 100);
    }
  }

  waitForLightbox(function() {
    // Lightboxが利用可能になった後に実行されるコード
    if (window.productImageSwiper) {
      window.productImageSwiper.on('slideChange', function () {
          var activeIndex = this.activeIndex;
        Lightbox.prototype.currentImageIndex = activeIndex;
      });
    }
  });

  document.querySelectorAll('.zoom-icon').forEach(function(zoomIcon) {
    zoomIcon.addEventListener('click', function() {
      console.log('zoom-icon clicked'); // クリックイベントが認識されているか確認するためのログ
      const activeSlide = document.querySelector('.swiper-slide-active a[data-lightbox="product-images"]');
      if (activeSlide) {
        console.log('Active slide found:', activeSlide); // アクティブなスライドが正しく取得されているか確認するためのログ
        activeSlide.click();
      } else {
        console.log('No active slide found'); // アクティブなスライドが見つからない場合のログ
      }
    });
  });
});
